import {getMessages} from 'app/store/constants';

export const TEMPLATE_TEXT = getMessages().getText('board_settings.actions.create_template.text');
export const TEMPLATE_TEXT_LINK = getMessages().getText('board_settings.actions.create_template.text.link');
export const TEMPLATE_BUTTON = getMessages().getText('board_settings.actions.create_template');

export const TEMPLATE_LINK = 'https://www.kanbanchi.com/faqwd/how-to-make-my-board-a-template';
